export const SkeletonSubProductCard: React.FC = () => {
  return (
    <div
      className="relative mb-10 rounded-2xl shadow-lg"
      style={{ maxWidth: '236px' }}
    >
      <div className="animate-pulse">
        <div className="h-[180px] w-full rounded-t-2xl bg-grey"></div>
        <div className="flex h-[134px] flex-col justify-between p-2 pb-6"></div>
      </div>
    </div>
  );
};
